<template>
  <div class="salRet" v-wechat-title="title">
    <div class="list">
      <ul>
        <li>
          <div class="product">
            <div v-if="list && list.length <= 1 && list.length > 0" class="productBox">
              <div class="productImg">
                <img v-lazy="list[0].img_path" />
                <goods-tag :goods="list[0]"></goods-tag>
              </div>
              <div class="proContent">
                <b>
                  {{ list[0].name.length > 26 ? list[0].name.slice(0, 26) + '...' : list[0].name }}
                </b>
                <p>
                  <b>{{ list[0].spec }}</b>
                </p>
              </div>
            </div>
            <div
              v-if="list && list.length > 1"
              class="productBox bestSellingSwiper"
              style="overflow: hidden; position: relative"
            >
              <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide v-for="(itemSon, idx) of list" :key="idx">
                  <img v-lazy="itemSon.img_path" />
                  <goods-tag :goods="itemSon"></goods-tag>
                </swiper-slide>
              </swiper>
            </div>
            <span class="totelPrice" :style="list && list.length > 1 ? {} : { position: 'static' }">
              <span class="price">
                {{
                  String(parseFloat(totalmoney).toFixed(2)).slice(
                    0,
                    String(parseFloat(totalmoney).toFixed(2)).indexOf('.')
                  )
                }}
                <i>
                  {{
                    String(parseFloat(totalmoney).toFixed(2)).slice(
                      String(parseFloat(totalmoney).toFixed(2)).indexOf('.'),
                      String(parseFloat(totalmoney).toFixed(2)).length
                    )
                  }}
                </i>
              </span>
              <b>共{{ totalnum }}件</b>
            </span>
          </div>
          <!--<div class="proFooter" @click="keFu">-->
          <!--<p><img src="../../assets/images/kefu.png">联系客服</p>-->
          <!--</div>-->
        </li>
      </ul>
    </div>
    <div class="why" v-if="order && order.orderstatus > 2 && type == 'refund'">
      <div class="title">
        <p>
          货物状态
          <span class="f13 color-FC0324">*</span>
        </p>
      </div>
      <div class="content" @click="goodsShow = true">
        <b v-if="chooseGoods && (!chooseGoods.name || chooseGoods.name == '')">选择货物状态</b>
        <b v-else-if="chooseGoods && (chooseGoods.name || chooseGoods.name != '')" class="choose">
          {{ chooseGoods.name }}
        </b>
        <img src="../../assets/images/jt3.png" />
      </div>
    </div>
    <div class="why">
      <div class="title">
        <p>
          申请原因
          <span class="f13 color-FC0324">*</span>
        </p>
      </div>
      <div class="content" @click="show = true">
        <b v-if="chooseCause && (!chooseCause.name || chooseCause.name == '')">选择申请原因</b>
        <b v-else-if="chooseCause && (chooseCause.name || chooseCause.name != '')" class="choose">
          {{ chooseCause.name }}
        </b>
        <img src="../../assets/images/jt3.png" />
      </div>
    </div>
    <article>
      <textarea
        v-model="textinput"
        name=""
        @blur="input_blur"
        id="afterEval"
        placeholder="申请理由描述…"
      ></textarea>
      <p>{{ textNum }}/200</p>
      <div class="evalPhotoBox">
        <van-uploader v-model="fileList" :max-count="5" preview-size="0.59rem" />
      </div>
    </article>
    <!--v-if="parseFloat(list.coupon_money) > 0"-->
    <div class="refundPrice">
      <p>退款金额</p>
      <b>¥{{ !isNaN(refundMoney) ? parseFloat(refundMoney).toFixed(2) : '0.00' }}</b>
    </div>
    <div class="refundPrice redRefundPrice" v-if="parseFloat(depositmoney) > 0">
      <p>定金</p>
      <b>¥{{ parseFloat(depositmoney).toFixed(2) }}</b>
    </div>
    <div v-if="parseFloat(discountcouponMoney) > 0" class="refundPrice redRefundPrice">
      <p>折扣券</p>
      <b>¥{{ parseFloat(discountcouponMoney).toFixed(2) }}</b>
    </div>
    <div v-if="parseFloat(couponMoney) > 0" class="refundPrice redRefundPrice">
      <p>现金券</p>
      <b>¥{{ parseFloat(couponMoney).toFixed(2) }}</b>
    </div>
    <div v-if="couponName" class="refundPrice redRefundPrice">
      <p>产品劵</p>
      <b>{{ couponName }}</b>
    </div>
    <!--v-if="parseFloat(list.integer_num) > 0"-->
    <div v-if="parseFloat(integerNum) > 0" class="refundPrice redRefundPrice">
      <p>金币</p>
      <b>{{ integerNum }}</b>
    </div>
    <footer class="footerIOS">
      <button class="btn" :class="{ graybtn: isrefund }" @click="submit">提交</button>
    </footer>
    <van-action-sheet v-model="show" title="申请原因" round>
      <!--<img @click="show = false" src="../../assets/images/close3.png" style="width: 0.2rem;height: 0.2rem;position: absolute;right: 0.16rem;top: 0.12rem;">-->
      <van-radio-group v-model="radio">
        <van-cell-group>
          <van-cell
            v-for="(item, index) of cause"
            :key="index"
            :title="item.name"
            clickable
            @click="causeOptClick(item)"
          >
            <van-radio class="radio" slot="right-icon" :name="item.id" checked-color="#FC0324" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-action-sheet>
    <van-action-sheet v-model="goodsShow" title="货物状态" round>
      <!--<img @click="show = false" src="../../assets/images/close3.png" style="width: 0.2rem;height: 0.2rem;position: absolute;right: 0.16rem;top: 0.12rem;">-->
      <van-radio-group v-model="goodsRadio">
        <van-cell-group>
          <van-cell
            v-for="(item, index) of goods"
            :key="index"
            :title="item.name"
            clickable
            @click="goodsOptClick(item)"
          >
            <van-radio class="radio" slot="right-icon" :name="item.id" checked-color="#FC0324" />
          </van-cell>
          <div style="height: 0.4rem"></div>
        </van-cell-group>
      </van-radio-group>
    </van-action-sheet>
    <van-dialog
      class="collect_button_alert after-sales-dialog"
      v-model="afterSalesShow"
      :message="afterSalesMessage"
      :before-close="beforeClose"
      @confirm="confirmDialog"
      @cancel="cancelDialog"
      confirm-button-text="联系客服"
      confirm-button-color="#FFFCFC"
      cancel-button-text="拨打电话"
      cancel-button-color="#FC0324"
      show-confirm-button
      show-cancel-button
    >
      <div slot="title">
        <img class="dialog-close" @click="closeDialogFn" src="../../assets/images/close3.png" />
      </div>
    </van-dialog>
    <van-dialog
      v-model="isshow"
      :title="bankmsg"
      :before-close="(action, done) => done(false)"
      @cancel="isshow = false"
      @confirm="submit"
      show-cancel-button
      cancel-button-color="#FC0324"
      class="signin_button_alert collect_button_alert"
    >
      <img class="message" src="/static/images/message@2x.png" />
      <ul>
        <li class="flex-ac">
          <p class="f14 flex-s">持卡人:</p>
          <div class="inp flex-ac">
            <input type="text" v-model="username" placeholder="请输入真实姓名" />
            <img
              class="del-btn"
              src="/static/wx/img/close3.png"
              v-if="username"
              @click="username = ''"
            />
          </div>
        </li>
        <li class="flex-ac">
          <p class="f14 flex-s">银行卡号:</p>
          <div class="inp flex-ac">
            <input type="tel" v-model="cardno" placeholder="请输入银行卡号" />
            <img
              class="del-btn"
              src="/static/wx/img/close3.png"
              v-if="cardno"
              @click="cardno = ''"
            />
          </div>
        </li>
        <li class="flex-ac">
          <p class="f14 flex-s">开户银行:</p>
          <div class="inp flex-ac">
            <input type="text" v-model="bankname" placeholder="请输入银行" />
            <img
              class="del-btn"
              src="/static/wx/img/close3.png"
              v-if="bankname"
              @click="bankname = ''"
            />
          </div>
          <span class="f12 color-9">例：招商银行</span>
        </li>
        <li class="flex-ac bank">
          <p class="f14 flex-s">支行地址:</p>
          <div class="inp flex-ac">
            <input type="text" v-model="subname" placeholder="请输入开户行地址" />
            <img
              class="del-btn"
              src="/static/wx/img/close3.png"
              v-if="subname"
              @click="subname = ''"
            />
          </div>
          <span class="f12 color-9">例：北京分行建国路支行</span>
        </li>
        <li class="flex-ac bank">
          <p class="f14 flex-s unimpor">联系电话:</p>
          <div class="inp flex-ac">
            <input type="tel" v-model="contact" placeholder="请输入联系电话" />
            <img
              class="del-btn"
              src="/static/wx/img/close3.png"
              v-if="contact"
              @click="contact = ''"
            />
          </div>
        </li>
      </ul>
    </van-dialog>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { isWeixin, kefu, fenxiang } from '../../assets/common/js/config'
import Vue from 'vue'
import goodsTag from '../common/goodsTag'
Vue.use(VueAwesomeSwiper /* { default global options } */)
export default {
  name: 'refundSalesReturn',
  components: {
    goodsTag
  },
  data() {
    return {
      title: this.$route.query.returnType == 'refund' ? '退款' : '退款退货',
      id: this.$route.query.id ? this.$route.query.id : '',
      type: this.$route.query.returnType ? this.$route.query.returnType : '',
      numtype: this.$route.query.type ? this.$route.query.type : '',
      allrefund: this.$route.query.allrefund ? this.$route.query.allrefund : 0,
      swiperOption: {
        autoplay: false,
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        observer: true,
        observeParents: true,
        spaceBetween: 10
      },
      kefuPhone: '',
      afterSalesShow: false,
      afterSalesMessage: '',
      value: 0,
      show: false,
      goodsShow: false,
      radio: 0,
      goodsRadio: 0,
      chooseCause: {},
      chooseGoods: {},
      deleteBool: false,
      textinput: '',
      textNum: 0,
      totalmoney: 0,
      totalnum: 0,
      discountcouponMoney: 0,
      couponMoney: 0,
      couponName: '',
      integerNum: 0,
      refundMoney: 0,
      ordersheetArr: [],
      numArr: [],
      list: sessionStorage.getItem('refundSales_data')
        ? JSON.parse(sessionStorage.getItem('refundSales_data'))
        : [],
      fileList: [],
      fileLen: null,
      imgpath: [],
      cause: [],
      goods: [
        {
          name: '未收到货',
          id: '1'
        },
        {
          name: '已收到货',
          id: '2'
        }
      ],
      isrefund: 0,
      depositmoney: 0,
      order: null,
      isshow: false,
      bankmsg: '',
      username: '',
      cardno: '',
      bankname: '',
      subname: '',
      contact: ''
    }
  },
  mounted: function () {
    this.$route.meta.title = this.title
    if (isWeixin()) {
      fenxiang({ path: 'refundsalesreturn' })
    }
    this.getData()
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  watch: {
    textinput(n) {
      if (n.length > 200) {
        this.textNum = 200
      } else {
        this.textNum = n.length
      }
      this.textinput = this.textinput.slice(0, 200)
    }
  },
  methods: {
    getData: function () {
      var url, salesUrl
      if (this.list) {
        this.list.map((item) => {
          this.ordersheetArr.push(item.ordersheet_id)
          this.numArr.push(item.num)
        })
      }
      url =
        this.$ajax.getRefundOrderMoney_URL +
        '?orderid=' +
        this.id +
        '&ordersheet_id=' +
        this.ordersheetArr.join() +
        '&num=' +
        this.numArr.join() +
        (this.allrefund ? '&allrefund=' + this.allrefund : '')
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          this.order = res.data
          this.order.orderstatus = parseInt(this.order.orderstatus)
          this.discountcouponMoney = res.data.refund_discountcoupon_money
          this.couponMoney = res.data.refund_coupon_money
          this.couponName = res.data.couponname
          this.integerNum = res.data.refund_integer_number
          this.refundMoney = res.data.refund_money
          this.depositmoney = res.data.depositmoney
          this.totalmoney = res.data.totalMoney
          this.totalnum = res.data.total
          this.list = res.data.itemList
        }
      })
      salesUrl = this.$ajax.getReturnReason_URL
      this.$customRequestAjax(salesUrl).then((res) => {
        if (res.data.code === 200) {
          this.cause = res.data.list
          for (var i = 0; i < this.cause.length; i++) {
            if (this.cause[i].id == this.list.reason_id) {
              this.chooseCause = this.cause[i]
            }
          }
        }
      })
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
    cosUploadImage(file, fn) {
      console.log(file)
      var that = this
      that.$cos.uploadFile({
        key: '/refundselesreturn_h5' + file.file.name,
        file: file.file,
        success: function (data) {
          that.imgpath.push(data)
          that.fileLen++
          if (that.fileLen >= that.fileList.length) {
            if (typeof fn === 'function') {
              fn()
            }
          } else {
            that.cosUploadImage(that.fileList[that.fileLen], function () {
              that.submitAxios()
            })
          }
        }
      })
    },
    // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
    uploadImage(file, fn) {
      console.log(file)
      var imgName = 'comments'
      var blob = this.dataURLtoBlob(file.content)
      var newFile = this.blobToFile(blob, imgName)
      const url = this.$ajax.getOssWeb_URL
      var that = this
      this.$customRequestAjax(url).then(async (res) => {
        if (res.data.code === 200) {
          const { accessid, host, policy, signature, dir } = res.data.data
          const fd = new FormData()
          let str = that.random_string(16) + newFile.name + '.png'
          fd.append('OSSAccessKeyId', accessid)
          fd.append('policy', policy)
          fd.append('Signature', signature)
          fd.append('key', `${dir}${str}`)
          fd.append('Filename', `${dir}${str}`)
          fd.append('success_action_status', 200)
          fd.append('file', newFile)
          let config = {
            // 添加请求头
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          that.$axios.post(host, fd, config).then((res) => {
            if (res.status == 200 && res.statusText == 'OK') {
              // var img = that.ossImgUrl + `${dir}${str}`
              var img = `${dir}${str}`.replace('Uploads/', '')
              that.imgpath.push(img)
              that.fileLen++
              if (that.fileLen >= that.fileList.length) {
                if (typeof fn === 'function') {
                  fn()
                }
              } else {
                that.uploadImage(that.fileList[that.fileLen], function () {
                  that.submitAxios()
                })
              }
            }
          })
        }
      })
    },
    // 将base64转换为blob
    dataURLtoBlob: function (dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile: function (theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    random_string: function (n) {
      var num = Math.pow(10, n)
      return Math.ceil(Math.random() * num) + '' + new Date().getTime()
    },
    closeDialogFn: function () {
      this.afterSalesShow = false
    },
    beforeClose: function (action, done) {
      if (action === 'confirm') {
        setTimeout(done, 1000)
      } else {
        done(false)
      }
    },
    confirmDialog: function () {
      var goodslist = [],
        goodsnum = 0
      this.order.itemlist.map((item) => {
        goodslist.push({
          name: item.name,
          pictureUrl: encodeURIComponent(item.img_path)
        })
        goodsnum += parseInt(item.num)
      })
      var k =
        'order_status=0&status_custom=' +
        this.order.orderstatus_text +
        '&create_time=' +
        new Date(this.order.ordertime.replace(/-/g, '/')).getTime() +
        '&order_code=' +
        this.order.no +
        '&order_url=' +
        encodeURIComponent(basepath + 'orderdetails?id=' + this.id) +
        '&goods_count=' +
        goodsnum +
        '&total_fee=' +
        parseInt(parseFloat(this.order.pay_money) * 100) +
        '&goods=' +
        JSON.stringify(goodslist)
      kefu(1, k)
      this.afterSalesShow = false
    },
    cancelDialog: function () {
      window.location.href = 'tel: ' + this.kefuPhone
    },
    submit: function () {
      var that = this
      if (this.chooseCause && (!this.chooseCause.name || this.chooseCause.name == '')) {
        this.$toast('请选择申请原因')
        return
      }
      if (
        this.order.orderstatus > 2 &&
        this.type == 'refund' &&
        this.chooseGoods &&
        (!this.chooseGoods.name || this.chooseGoods.name == '')
      ) {
        this.$toast('请选择货物状态')
        return
      }
      if (this.isshow) {
        if (!this.username.trim()) {
          this.username = ''
          this.$toast('请输入持卡人姓名')
          return
        }
        if (!this.cardno.trim()) {
          this.cardno = ''
          this.$toast('请输入银行卡号')
          return
        }
        if (!this.bankname.trim()) {
          this.bankname = ''
          this.$toast('请输入开户银行')
          return
        }
        if (!this.subname.trim()) {
          this.subname = ''
          this.$toast('请输入支行地址')
          return
        }
        this.isshow = false
        f()
      } else {
        this.$toast.loading({
          mask: true,
          message: '正在提交',
          duration: 0,
          forbidClick: true
        })
        var url = this.$ajax.getRefundBankCardInfo_URL + '?orderid=' + this.id
        this.$customRequestAjax(url)
          .then((res) => {
            if (res.data.code == 200) {
              if (res.data.showpup == 1) {
                this.bankmsg = res.data.msg
                this.isshow = true
              } else {
                f()
              }
            } else {
              f()
            }
          })
          .catch((err) => {
            f()
          })
      }
      function f() {
        that.$toast.loading({
          mask: true,
          message: '正在提交',
          duration: 0,
          forbidClick: true
        })
        that.fileLen = 0
        if (that.fileLen < that.fileList.length) {
          // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui Start
          that[that.$cos.isCosSwitch == 1 ? 'cosUploadImage' : 'uploadImage'](
            that.fileList[that.fileLen],
            function () {
              that.submitAxios()
            }
          )
          // 2024.3.18阿里云迁移-对象存储-上传图片视频调整-4 Mod by gaoenhui End
        } else {
          that.submitAxios()
        }
      }
    },
    submitAxios: function () {
      var url = this.$ajax.addApplyOrder_URL,
        that = this
      var data = {
        orderid: this.id,
        ordersheet_id: this.ordersheetArr.join(),
        num: this.numArr.join(),
        reason_id: this.chooseCause.id,
        reason_name: this.chooseCause.name,
        apply_reason: this.textinput,
        type: this.type == 'refund' ? 1 : 2,
        path1: this.imgpath[0] ? this.imgpath[0] : '',
        path2: this.imgpath[1] ? this.imgpath[1] : '',
        path3: this.imgpath[2] ? this.imgpath[2] : '',
        path4: this.imgpath[3] ? this.imgpath[3] : '',
        path5: this.imgpath[4] ? this.imgpath[4] : '',
        username: this.username ? this.username : '',
        cardno: this.cardno ? this.cardno : '',
        bankname: this.bankname ? this.bankname : '',
        subname: this.subname ? this.subname : '',
        contact: this.contact ? this.contact : '',
        ...(this.allrefund ? { allrefund: this.allrefund } : {})
      }
      if (this.order.orderstatus > 2)
        data.goodstatus = this.chooseGoods.id ? this.chooseGoods.id : 0
      if (this.isrefund) {
        return
      }
      this.isrefund = 1
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code === 200) {
          if (this.type == 'refund' && res.data.msg != '') {
            this.$toast(res.data.msg)
            setTimeout(function () {
              Func()
            })
          } else if (res.data.msg != '') {
            that.$toast.clear()
            that.$dialog
              .alert({
                title: '',
                message: res.data.msg,
                className: 'percen_button_alert',
                confirmButtonColor: '#FFFCFC',
                confirmButtonText: '我知道了',
                closeOnPopstate: false
              })
              .then(function () {
                // on confirm
                Func()
              })
          } else {
            Func()
          }
          function Func() {
            if (that.allrefund == 1) {
              that.$store.commit('ORDERLIST_NAVID', 4)
              that.$router.replace('/myorder')
            } else {
              that.$store.commit('ORDER_INIT_DATA', 1)
              that.$router.replace({
                path: '/afterdetails',
                query: {
                  id: res.data.refund_id,
                  message: ''
                }
              })
            }
          }
        } else if (res.data.code == 6006) {
          this.isrefund = 0
          this.$toast.clear()
          this.afterSalesMessage = res.data.msg
          this.kefuPhone = res.data.phone
          this.afterSalesShow = true
        } else if (res.data.code == 6007) {
          this.isrefund = 0
          this.$toast.clear()
          this.$router.push({
            path: '/splitdetails',
            query: {
              id: this.id
            }
          })
        } else {
          this.isrefund = 0
        }
      })
    },
    causeOptClick: function (items) {
      this.radio = items.id
      var that = this
      setTimeout(function () {
        that.chooseCause = items
        that.show = false
      }, 200)
    },
    goodsOptClick: function (items) {
      this.goodsRadio = items.id
      var that = this
      setTimeout(function () {
        that.chooseGoods = items
        that.goodsShow = false
      }, 200)
    },
    input_blur() {
      // document.body.scrollTop = document.documentElement.scrollTop - 1
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight, 0))
      }, 100)
    },
    handlechange() {
      var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
      // var reg = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;
      if (this.textinput.match(reg)) {
        this.textinput = this.textinput.replace(reg, '')
      }
      this.textinput = this.textinput.replace(/\s+/g, '')
    }
    // keFu: function () {
    //   kefu()
    // }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/common/css/footerSubmit';
.list ul li p,
.list ul li .proFooter,
.product,
.why {
  display: flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -webkit-flex;
  display: -o-flex;
  justify-content: space-between;
  -moz-justify-content: space-between;
  -ms-justify-content: space-between;
  -webkit-justify-content: space-between;
  -o-justify-content: space-between;
  align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
}
.salRet {
  .signin_button_alert.van-dialog {
    width: 90%;
    overflow: initial;
    .message {
      width: 0.87rem;
      height: 0.87rem;
      position: absolute;
      top: -0.43rem;
      left: 50%;
      margin-left: -0.43rem;
      z-index: 1;
    }
  }
  .signin_button_alert .van-dialog__footer .van-dialog__confirm {
    width: 80.53%;
  }
  .signin_button_alert ul {
    padding: 0 0.19rem;
  }
  .signin_button_alert ul li {
    width: 100%;
    margin-top: 0.07rem;
    padding: 0 0.07rem 0 0.1rem !important;
    align-items: center;
    -webkit-align-items: center;
    position: relative;
  }
  .signin_button_alert ul li.bank {
    margin-top: 0.23rem;
  }
  .signin_button_alert ul li span {
    position: absolute;
    left: 0.85rem;
    top: 0.36rem;
  }
  .signin_button_alert ul li p {
    color: #333;
    width: 0.7rem;
    position: relative;
    &.unimpor {
      &:before {
        display: none;
      }
    }
    &:before {
      content: '*';
      font-size: 0.1rem;
      color: #fc0324;
      position: absolute;
      left: -0.06rem;
    }
  }
  .signin_button_alert ul li .inp {
    height: 0.3rem;
    width: 100%;
    background: #f6f7fa;
    margin-top: 0.05rem;
    padding: 0 0.07rem 0 0.1rem !important;
    border: none !important;
    border-radius: 0.08rem;
    align-items: center;
    -webkit-align-items: center;
  }
  .signin_button_alert ul li .del-btn {
    width: 0.13rem;
    height: 0.13rem;
    border: none;
  }
  .signin_button_alert ul li img {
    width: 0.85rem;
    flex-shrink: 0;
    -webkit-flex-shrink: 0;
    height: 0.32rem;
    margin-left: 0.07rem;
    border: 0.01rem solid #5d6bfb;
    border-radius: 0.02rem;
  }
  .signin_button_alert ul li i {
    font-size: 0.13rem;
    color: #5d6bfb;
    font-style: normal;
    flex-shrink: 0;
    -webkit-flex-shrink: 0;
    margin-left: 0.07rem;
  }
  .signin_button_alert ul li:first-of-type {
    margin-top: 0;
  }
  .signin_button_alert ul li input {
    height: 100%;
    width: 100%;
    font: initial;
    padding: 0 !important;
    border: none;
    outline: none;
    background: #f6f7fa;
    color: #333333;
  }
  .signin_button_alert ul li input::placeholder {
    color: #999999;
    font-size: 0.13rem;
  }
  .list {
    > ul {
      margin-bottom: 0.11rem;
      > li {
        background: #fff;
        margin: 0.11rem 0.11rem 0;
        padding: 0.15rem 0.15rem 0;
        > p {
          border-bottom: 1px solid #efefef;
          padding-bottom: 0.1rem;
          span {
            display: block;
            b {
              display: block;
              font-weight: 400;
              color: #444444;
              font-size: 0.12rem;
              float: left;
              &:last-of-type {
                margin-left: 0.04rem;
              }
            }
          }
          i {
            font-style: normal;
            color: #292929;
            font-size: 0.12rem;
            display: flex;
            display: -o-flex;
            display: -webkit-flex;
            display: -ms-flex;
            display: -moz-flex;
            align-items: center;
            -o-align-items: center;
            -webkit-align-items: center;
            -ms-align-items: center;
            -moz-align-items: center;
            b {
              border-left: 1px solid #d8d8d8;
              margin-left: 0.06rem;
              padding-left: 0.07rem;
              display: flex;
              display: -o-flex;
              display: -webkit-flex;
              display: -ms-flex;
              display: -moz-flex;
              align-items: center;
              -o-align-items: center;
              -webkit-align-items: center;
              -ms-align-items: center;
              -moz-align-items: center;
              img {
                width: 0.12rem;
                height: 0.12rem;
              }
            }
          }
        }
        .product {
          position: relative;
          padding-bottom: 0.2rem;
          .productBox {
            display: flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -webkit-flex;
            display: -o-flex;
            .productImg {
              width: 0.8rem;
              height: 0.8rem;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .proContent {
              margin-left: 0.07rem;
              margin-top: 0.08rem;
              flex: 1;
              -webkit-flex: 1;
              -moz-flex: 1;
              -ms-flex: 1;
              -o-flex: 1;
              > b {
                font-size: 0.13rem;
                font-weight: 400;
                color: rgba(41, 41, 41, 1);
                line-height: 0.18rem;
                display: block;
                margin-bottom: 0.05rem;
              }
              > p {
                align-items: flex-start;
                -moz-align-items: flex-start;
                -ms-align-items: flex-start;
                -webkit-align-items: flex-start;
                -o-align-items: flex-start;
                > b {
                  font-size: 0.11rem;
                  font-weight: 400;
                  color: rgba(108, 108, 108, 1);
                  line-height: 0.16rem;
                  display: block;
                }
              }
              .choicesNum {
                height: 0.22rem;
                margin-top: 0.11rem;
              }
            }
          }
          .totelPrice {
            position: absolute;
            right: 0;
            z-index: 10;
            opacity: 0.85;
            height: 0.8rem;
            display: flex;
            display: -webkit-flex;
            display: -o-flex;
            display: -ms-flex;
            display: -moz-flex;
            flex-direction: column;
            -webkit-flex-direction: column;
            -o-flex-direction: column;
            -ms-flex-direction: column;
            -moz-flex-direction: column;
            justify-content: center;
            -webkit-justify-content: center;
            -o-justify-content: center;
            -ms-justify-content: center;
            -moz-justify-content: center;
            .price {
              display: flex;
              display: -webkit-flex;
              display: -o-flex;
              display: -ms-flex;
              display: -moz-flex;
              align-items: flex-end;
              -webkit-align-items: flex-end;
              -o-align-items: flex-end;
              -ms-align-items: flex-end;
              -moz-align-items: flex-end;
              font-size: 0.14rem;
              font-weight: 600;
              color: #222222;
              line-height: 0.14rem;
              &:before {
                content: '￥';
                font-size: 0.1rem;
                font-weight: 600;
                line-height: 0.14rem;
              }
              i {
                font-size: 0.11rem;
                font-style: normal;
                line-height: 0.14rem;
              }
            }
            > b {
              color: #908d8d;
              font-size: 0.11rem;
              line-height: 0.16rem;
              display: block;
              font-weight: 400;
              text-align: center;
            }
          }
          .bestSellingSwiper {
            .swiper-container {
              padding-right: 0.6rem;
            }
            .swiper-wrapper {
              .swiper-slide {
                width: 0.8rem;
                height: 0.8rem;
                position: relative;
                background-color: white;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
            & + .totelPrice {
              background: rgba(255, 255, 255, 1);
              box-shadow: -0.2rem 0 0.09rem -0.16rem rgba(156, 156, 156, 0.5);
            }
          }
        }
        .proFooter {
          margin-top: 0.2rem;
          border-top: 1px solid rgba(216, 216, 216, 1);
          justify-content: center;
          height: 0.37rem;
          > p {
            font-size: 0.12rem;
            font-weight: 400;
            color: #363636;
            line-height: 0.17rem;
            padding: 0.1rem auto;
            img {
              width: 0.15rem;
              height: 0.15rem;
            }
          }
        }
      }
    }
  }
  .dialog-close {
    width: 0.2rem;
    height: 0.2rem;
    position: absolute;
    top: 0.06rem;
    right: 0.06rem;
  }
}
.why {
  padding: 0.14rem 0.1rem 0.13rem 0.15rem;
  margin: 0.1rem 0.11rem;
  background: #fff;
  border-radius: 0.03rem;
  .title {
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
    img {
      width: 0.3rem;
      height: 0.3rem;
    }
    p {
      font-size: 0.15rem;
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
      line-height: 0.21rem;
      /*margin-left: 0.1rem;*/
    }
  }
  .content {
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
    b {
      display: block;
      font-size: 0.11rem;
      font-weight: 400;
      color: rgba(176, 176, 176, 1);
      line-height: 0.16rem;
      margin-right: 0.06rem;
      &.choose {
        color: #444444;
      }
    }
    img {
      width: 0.1rem;
      height: 0.1rem;
      padding: 0.01rem 0.02rem;
    }
  }
}
article {
  background: #fff;
  margin: 0 0.11rem 0.1rem;
  padding: 0.15rem 0.2rem;
  border-radius: 0.04rem;
  #afterEval {
    display: block;
    width: 100%;
    min-height: 1.43rem;
    border: none;
    outline: none;
    line-height: 0.18rem;
    font-size: 0.13rem;
    color: #333;
    &::placeholder {
      font-size: 0.13rem;
      color: #999999;
      line-height: 0.18rem;
    }
  }
  p {
    font-size: 0.11rem;
    color: #b0b0b0;
    text-align: right;
  }
  .evalPhotoBox {
    display: -o-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: flex;
    align-items: flex-end;
    -webkit-align-items: flex-end;
    -o--align-items: flex-end;
    -moz--align-items: flex-end;
    -ms--align-items: flex-end;
  }
}
.refundPrice {
  height: 0.45rem;
  padding: 0.14rem 0.15rem 0.13rem;
  margin: 0 0.11rem;
  background: #fff;
  border-radius: 0.03rem;
  &.redRefundPrice b {
    color: rgba(0, 0, 0, 1);
  }
  p {
    float: left;
    font-size: 0.13rem;
    font-weight: 600;
    color: rgba(0, 0, 0, 1);
    line-height: 0.18rem;
  }
  b {
    float: right;
    display: block;
    font-size: 0.13rem;
    font-weight: 400;
    color: rgba(237, 62, 62, 1);
    line-height: 0.18rem;
  }
}
footer .btn {
  &.graybtn {
    background: #ccc;
  }
}
</style>
<style lang="scss">
@import '../../assets/common/css/popUp';
.salRet {
  padding-bottom: 0.79rem;

  .signin_button_alert .van-dialog__header {
    font-weight: normal;
    font-size: 0.12rem;
    line-height: 0.2rem;
    padding: 0.41rem 0.15rem 0;
  }
  .van-action-sheet__header {
    line-height: 0.52rem;
  }
  .van-action-sheet__content {
    .van-cell:not(:last-child)::after {
      display: none;
    }
  }
  .van-radio .van-radio__icon {
    height: auto;
  }
  .after-sales-dialog {
    .van-dialog__header {
      padding-top: 0.06rem;
    }
    .van-dialog__content {
      padding-top: 0.4rem;
    }
  }
  .van-action-sheet__header {
    line-height: 0.52rem;
  }
  .van-cell:not(:last-child)::after {
    border-bottom: 1px solid transparent;
  }
  .van-cell-group {
    padding-top: 0.17rem;
  }
  .van-cell {
    padding-top: 0.075rem;
    padding-bottom: 0.075rem;
    &:first-of-type {
      padding-top: 0;
    }
    .van-cell__title {
      span {
        font-size: 0.15rem;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        line-height: 0.21rem;
      }
    }
    .van-radio {
      .van-radio__icon {
        font-size: 0.18rem;
        line-height: 0.18rem;
        width: 0.18rem;
        height: 0.18rem;
        .van-icon {
          width: 0.18rem;
          height: 0.18rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/after/refundSalesReturn.vue